import { z } from '@/libs/zod';
import { parseDigits } from '@/utils';
import { removeDDIFromAutoInsert } from '@/utils/formatters';

export const editProfileSchema = z
  .object({
    actualPhone: z.string().trim().min(1, 'Telefone é obrigatório'),
    newPhone: z.string().trim().min(1, 'Novo telefone é obrigatório'),
    confirmNewPhone: z
      .string()
      .trim()
      .min(1, 'Confirmação de novo telefone é obrigatória'),
  })
  .transform((data) => ({
    ...data,
    actualPhone: removeDDIFromAutoInsert(parseDigits(data.actualPhone)),
    newPhone: removeDDIFromAutoInsert(parseDigits(data.newPhone)),
    confirmNewPhone: removeDDIFromAutoInsert(parseDigits(data.confirmNewPhone)),
  }))
  .superRefine((data, ctx) => {
    if (data.newPhone !== data.confirmNewPhone) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['confirmNewPhone'],
        message: 'Confirmação deve ser igual ao novo telefone',
      });
    }
    if (data.newPhone === data.actualPhone) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['newPhone'],
        message: 'Novo telefone deve ser diferente do telefone atual',
      });
    }
  });

export type EditProfileFormData = z.infer<typeof editProfileSchema>;
